/* Orbit – Produktseite Cacao Rituals
   Galerie, Zoom, 3D-Neigung des Gold-Dreiecks, sanftes Einblenden, Sticky-Leiste.
   Keine externen Bibliotheken. Warenkorb und Varianten laufen über die Theme-Skripte
   (product-form.js, global.js → variant-radios). */
(function () {
  if (window.orbitPdp) return;
  window.orbitPdp = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.documentElement.classList.add('orbit-js');

  /* ---------- Galerie ---------- */
  function initGallery(gal) {
    if (gal.dataset.oReady) return;
    gal.dataset.oReady = '1';
    var slides = gal.querySelectorAll('[data-o-slide]');
    var thumbs = gal.querySelectorAll('[data-o-thumb]');
    var zoomBtn = gal.querySelector('[data-o-zoom]');
    var current = 0;

    function show(i, focusThumb) {
      if (!slides.length) return;
      current = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) {
        var on = n === current;
        s.classList.toggle('is-active', on);
        s.setAttribute('aria-hidden', on ? 'false' : 'true');
        if (!on) s.querySelectorAll('video').forEach(function (v) { v.pause(); });
      });
      thumbs.forEach(function (t, n) { t.setAttribute('aria-current', n === current ? 'true' : 'false'); });
      if (focusThumb && thumbs[current]) thumbs[current].focus();
      if (zoomBtn) zoomBtn.hidden = !slides[current].querySelector('img[data-o-full]');
    }

    thumbs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); show(current + 1, true); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); show(current - 1, true); }
      });
    });

    /* Wischen auf dem Handy */
    var main = gal.querySelector('.o-gal__main');
    var x0 = null;
    if (main) {
      main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
        x0 = null;
      });
    }

    /* Variante gewechselt → zugehöriges Bild zeigen */
    var section = gal.closest('[data-o-section]');
    if (section) {
      section.addEventListener('change', function (e) {
        if (!e.target.closest('variant-radios, variant-selects')) return;
        window.setTimeout(function () {
          var input = section.querySelector('form[action*="/cart/add"] input[name="id"]');
          if (!input) return;
          var map = {};
          try { map = JSON.parse('{' + (gal.dataset.oVariantMedia || '') + '}'); } catch (err) {}
          var mediaId = map[input.value];
          if (!mediaId) return;
          slides.forEach(function (s, n) { if (s.dataset.oMediaId === String(mediaId)) show(n); });
        }, 0);
      });
    }

    /* Zoom */
    var dialog = gal.querySelector('dialog');
    if (zoomBtn && dialog && typeof dialog.showModal === 'function') {
      var img = dialog.querySelector('img');
      zoomBtn.addEventListener('click', function () {
        var src = slides[current].querySelector('img[data-o-full]');
        if (!src) return;
        img.src = src.dataset.oFull;
        img.alt = src.alt;
        dialog.showModal();
      });
      dialog.addEventListener('click', function (e) { if (e.target === dialog || e.target.closest('[data-o-close]')) dialog.close(); });
    } else if (zoomBtn) {
      zoomBtn.hidden = true;
    }
    show(0);
  }

  /* ---------- 3D-Neigung ---------- */
  function initTilt(el) {
    if (reduce || el.dataset.oReady || !window.matchMedia('(pointer: fine)').matches) return;
    el.dataset.oReady = '1';
    var host = el.closest('.orbit-pdp') || document.body;
    host.addEventListener('pointermove', function (e) {
      var r = host.getBoundingClientRect();
      var px = (e.clientX - r.left) / r.width - 0.5;
      var py = (e.clientY - r.top) / r.height - 0.5;
      el.style.setProperty('--o-ry', (px * 26).toFixed(2) + 'deg');
      el.style.setProperty('--o-rx', (-py * 18).toFixed(2) + 'deg');
    });
    host.addEventListener('pointerleave', function () {
      el.style.removeProperty('--o-ry');
      el.style.removeProperty('--o-rx');
    });
  }

  /* ---------- Einblenden ---------- */
  var revealObserver = null;
  function initReveal(el) {
    if (reduce || !('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
    if (!revealObserver) {
      revealObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.isIntersecting) { en.target.classList.add('is-in'); revealObserver.unobserve(en.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' });
    }
    revealObserver.observe(el);
  }

  /* ---------- Sticky-Leiste ---------- */
  /* Kakao-Test: 3 Fragen → Empfehlung (Karten sind im Liquid gerendert, hier nur ein-/ausblenden) */
  function initQuiz(q) {
    if (q.dataset.oQuizReady) return;
    q.dataset.oQuizReady = '1';
    var steps = q.querySelectorAll('.o-quiz__step');
    var bars = q.querySelectorAll('.o-quiz__bar i');
    var res = q.querySelector('.o-quiz__result');
    var a = [];
    function bar(i) { bars.forEach(function (b, k) { b.classList.toggle('is-on', k <= i); }); }
    function go(i) {
      res.hidden = true;
      steps.forEach(function (s, k) { s.hidden = k !== i; });
      bar(i);
      var first = steps[i].querySelector('.o-quiz__o');
      if (first && a.length) first.focus();
    }
    function pick() {
      if (a[0] === 'top') return 'nibs';
      if (a[0] === 'back') return 'klassik';
      if (a[0] === 'alles') return 'bundle';
      if (a[1] === 'offen') return 'starter';
      if (a[1] === 'mild') return 'klassik';
      return 'zeremonie';
    }
    function show() {
      steps.forEach(function (s) { s.hidden = true; });
      bar(2);
      var gift = a[2] === 'gift';
      /* Geschenk: passendes Produkt + Gutschein; Geschenkbox nur bei Trinkschokolade (Wunsch Inhaberin) */
      var keys;
      if (!gift) keys = [pick()];
      else if (a[0] === 'trink') keys = a[1] === 'offen' ? ['starter', 'box', 'gutschein'] : [pick(), 'box', 'gutschein'];
      else keys = [pick(), 'gutschein'];
      var shown = 0;
      q.querySelectorAll('.o-quiz__card').forEach(function (c) {
        var on = keys.indexOf(c.dataset.r) > -1;
        c.hidden = !on;
        if (on) shown++;
        var w = c.querySelector('[data-why]');
        if (w) w.hidden = gift;
      });
      if (!shown && gift) {
        var fb = q.querySelector('.o-quiz__card[data-r="' + pick() + '"]');
        if (fb) fb.hidden = false;
      }
      var t = q.querySelector('[data-r-title]');
      if (t) t.textContent = gift ? t.dataset.gift : t.dataset.me;
      var gl = q.querySelector('[data-r-giftlead]');
      if (gl) gl.hidden = !gift;
      var h = q.querySelector('[data-r-hint]');
      var k = keys[0];
      var single = !gift && (k === 'klassik' || k === 'zeremonie' || k === 'nibs');
      if (h) h.hidden = !single;
      q.querySelectorAll('[data-probe]').forEach(function (p) { p.hidden = !(single && p.dataset.probe === k); });
      res.hidden = false;
      res.focus({ preventScroll: true });
    }
    steps.forEach(function (s, i) {
      s.querySelectorAll('.o-quiz__o').forEach(function (b) {
        b.addEventListener('click', function () {
          a[i] = b.dataset.v;
          if (i === 0 && a[0] !== 'trink') { a[1] = '-'; go(2); }
          else if (i < 2) go(i + 1);
          else show();
        });
      });
      var bk = s.querySelector('[data-back]');
      if (bk) bk.addEventListener('click', function () { go(i === 2 && a[0] !== 'trink' ? 0 : i - 1); });
    });
    var rs = q.querySelector('[data-restart]');
    if (rs) rs.addEventListener('click', function () { a = []; go(0); });
  }

  /* Rezept zum Einkaufen: Einkaufszeile an der ersten Zutat, die auf das Produkt verlinkt */
  function initRezept(sec) {
    if (sec.dataset.oRzReady) return;
    sec.dataset.oRzReady = '1';
    var content = document.querySelector('.article-template__content');
    if (!content) return;
    sec.querySelectorAll('template[data-o-rz-row]').forEach(function (tpl) {
      var h = tpl.getAttribute('data-o-rz-row');
      var li = null;
      content.querySelectorAll('li a[href*="/products/"]').forEach(function (a) {
        if (li) return;
        var path;
        try { path = new URL(a.getAttribute('href'), location.origin).pathname; } catch (e) { return; }
        if (path.replace(/\/$/, '').split('/products/')[1] === h) li = a.closest('li');
      });
      if (!li || li.classList.contains('o-rz-row')) return;
      var frag = document.importNode(tpl.content, true);
      var img = frag.querySelector('.o-rz-row__img');
      var end = frag.querySelector('.o-rz-row__end');
      var txt = document.createElement('span');
      txt.className = 'o-rz-row__txt';
      while (li.firstChild) txt.appendChild(li.firstChild);
      li.classList.add('orbit-pdp', 'o-rz-row');
      if (img) li.appendChild(img);
      li.appendChild(txt);
      li.appendChild(end);
      /* bündig im Listenkasten: links gleich viel Abstand wie rechts (Aufzählungs-Einzug ausgleichen) */
      var list = li.parentElement;
      function align() {
        var cs = getComputedStyle(list);
        var d = parseFloat(cs.paddingLeft) - parseFloat(cs.paddingRight);
        li.style.marginLeft = d > 0 ? (-d) + 'px' : '';
      }
      align();
      if (window.ResizeObserver) new ResizeObserver(align).observe(list);
      else window.addEventListener('resize', align);
    });
  }

  /* Trustpilot-Wertung: beim Hineinscrollen füllen sich die Sterne exakt und die Zahl zählt hoch */
  function initTpAnim(stars) {
    if (stars.dataset.oTpReady) return;
    stars.dataset.oTpReady = '1';
    var group = stars.parentElement, num = null;
    for (var up = 0; up < 3 && group && !num; up++) {
      num = group.querySelector('[data-tp="score"]');
      if (!num) group = group.parentElement;
    }
    if (reduce || !('IntersectionObserver' in window)) return;
    stars.classList.add('o-tp-wait');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        io.disconnect();
        requestAnimationFrame(function () { stars.classList.remove('o-tp-wait'); });
        if (!num) return;
        var tries = 0;
        (function count() {
          var target = parseFloat((num.textContent || '').replace(',', '.'));
          if (!target) { if (tries++ < 30) setTimeout(count, 100); return; }
          var t0 = performance.now(), dur = 1400;
          (function step(t) {
            var p = Math.min(1, (t - t0) / dur);
            var v = target * (1 - Math.pow(1 - p, 3));
            num.textContent = (p < 1 ? v : target).toFixed(1);
            if (p < 1) requestAnimationFrame(step);
          })(t0);
        })();
      });
    }, { threshold: 0.4 });
    io.observe(stars);
  }

  function initSticky(bar) {
    if (bar.dataset.oReady || !('IntersectionObserver' in window)) return;
    bar.dataset.oReady = '1';
    var hero = document.querySelector('[data-o-hero] [name="add"]');
    var stoppers = document.querySelectorAll('[data-o-final], .footer, footer');
    var heroVisible = true, stopperVisible = false;

    function update() {
      var show = !heroVisible && !stopperVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button, input').forEach(function (n) { n.tabIndex = show ? 0 : -1; });
    }

    if (hero) {
      new IntersectionObserver(function (en) { heroVisible = en[0].isIntersecting || en[0].boundingClientRect.top > 0; update(); }).observe(hero);
    } else {
      heroVisible = false;
    }
    var seen = new Map();
    var so = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { seen.set(en.target, en.isIntersecting); });
      stopperVisible = Array.from(seen.values()).some(Boolean);
      update();
    });
    stoppers.forEach(function (s) { so.observe(s); });

    /* Variante im Kaufbereich → auch in der Leiste */
    document.addEventListener('change', function (e) {
      if (!e.target.matches('[data-o-hero] form[action*="/cart/add"] input[name="id"]')) return;
      bar.querySelectorAll('input[name="id"]').forEach(function (i) { i.value = e.target.value; });
    });
    update();
  }

  /* Abschluss-Formular ebenfalls mit der Variante im Kaufbereich abgleichen */
  document.addEventListener('change', function (e) {
    if (!e.target.matches('[data-o-hero] form[action*="/cart/add"] input[name="id"]')) return;
    document.querySelectorAll('[data-o-final] input[name="id"]').forEach(function (i) { i.value = e.target.value; });
  });

  /* ---------- Lichtreflex auf dem Symbol (folgt Maus bzw. Scrollen) ---------- */
  var syms = [], symObs = null, pointer = null, pTimer = null, rafOn = false;
  function symLoop() { if (!rafOn) { rafOn = true; requestAnimationFrame(symStep); } }
  function symStep(t) {
    rafOn = false;
    var any = false, vh = window.innerHeight || 800;
    syms.forEach(function (s) {
      if (!s.vis) return;
      any = true;
      var r = s.el.getBoundingClientRect();
      if (!r.width) return;
      var tx, ty;
      if (pointer) {
        tx = Math.max(-30, Math.min(230, (pointer.x - r.left) / r.width * 200));
        ty = Math.max(-30, Math.min(210, (pointer.y - r.top) / r.height * 180));
      } else {
        var p = (r.top + r.height / 2) / vh;
        tx = 30 + p * 140 + Math.sin(t / 2600 + s.seed) * 30;
        ty = 40 + Math.cos(t / 3300 + s.seed) * 45 + p * 40;
      }
      s.x += (tx - s.x) * 0.07; s.y += (ty - s.y) * 0.07;
      s.g.setAttribute('cx', s.x.toFixed(1)); s.g.setAttribute('cy', s.y.toFixed(1));
    });
    if (any) symLoop();
  }
  function initSym(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var g = el.querySelector('[data-o-glint]');
    if (!g || reduce) return;
    var s = { el: el, g: g, x: 100, y: 60, vis: false, seed: syms.length * 1.7 };
    syms.push(s);
    if (!('IntersectionObserver' in window)) { s.vis = true; symLoop(); return; }
    if (!symObs) {
      symObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { syms.forEach(function (o) { if (o.el === en.target) o.vis = en.isIntersecting; }); });
        symLoop();
      });
    }
    symObs.observe(el);
  }
  document.addEventListener('pointermove', function (e) {
    if (e.pointerType !== 'mouse') return;
    pointer = { x: e.clientX, y: e.clientY };
    clearTimeout(pTimer);
    pTimer = setTimeout(function () { pointer = null; }, 3500);
  }, { passive: true });

  /* ---------- Goldschimmer auf Karten (folgt der Maus) ---------- */
  document.addEventListener('pointermove', function (e) {
    if (reduce || e.pointerType !== 'mouse' || !e.target.closest) return;
    var c = e.target.closest('.orbit-pdp .o-glow');
    if (!c) return;
    var r = c.getBoundingClientRect();
    c.style.setProperty('--o-mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
    c.style.setProperty('--o-my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
  }, { passive: true });

  /* ---------- Ritual-Bühne: Schritte anklickbar, laufen von selbst weiter ---------- */
  function initRitual(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var tabs = [].slice.call(el.querySelectorAll('[data-o-rtab]'));
    var scenes = [].slice.call(el.querySelectorAll('[data-o-rscene]'));
    var caps = [].slice.call(el.querySelectorAll('[data-o-rcap]'));
    if (!tabs.length) return;
    var cur = 0, timer = null, paused = false, inView = false;
    var dur = parseInt(el.dataset.oDur || '5600', 10);
    el.style.setProperty('--o-rdur', dur + 'ms');
    function restart() {
      clearTimeout(timer);
      el.classList.remove('is-playing');
      void el.offsetWidth;
      if (!reduce && !paused && inView) {
        el.classList.add('is-playing');
        timer = setTimeout(function () { show(cur + 1); }, dur);
      }
    }
    function show(i) {
      cur = (i + tabs.length) % tabs.length;
      tabs.forEach(function (t, n) {
        var on = n === cur;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        t.parentNode.classList.toggle('is-active', on);
      });
      scenes.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); });
      caps.forEach(function (c, n) { c.classList.toggle('is-active', n === cur); });
      restart();
    }
    tabs.forEach(function (t, n) {
      t.addEventListener('click', function () { show(n); });
      t.addEventListener('keydown', function (e) {
        var k = e.key, d = (k === 'ArrowDown' || k === 'ArrowRight') ? 1 : (k === 'ArrowUp' || k === 'ArrowLeft') ? -1 : 0;
        if (!d) return;
        e.preventDefault(); show(cur + d); tabs[cur].focus();
      });
    });
    /* Wischen auf der Bühne (Handy) */
    var stage = el.querySelector('.o-ritual__stage'), x0 = null, y0 = 0;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
        x0 = null;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { paused = true; show(cur + (dx < 0 ? 1 : -1)); }
      }, { passive: true });
    }
    var list = el.querySelector('.o-ritual__list') || el;
    list.addEventListener('mouseenter', function () { paused = true; restart(); });
    list.addEventListener('mouseleave', function () { paused = false; restart(); });
    el.addEventListener('focusin', function () { paused = true; restart(); });
    el.addEventListener('focusout', function (e) { if (!el.contains(e.relatedTarget)) { paused = false; restart(); } });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { inView = en[0].isIntersecting; restart(); }, { threshold: 0.35 }).observe(el);
    } else { inView = true; }
    show(0);
  }

  /* ---------- Themen-Reiter (Fragen) ---------- */
  function initTopics(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var chips = [].slice.call(el.querySelectorAll('[data-o-topic]'));
    var items = [].slice.call(el.querySelectorAll('[data-o-topics]'));
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        var f = c.dataset.oTopic;
        chips.forEach(function (o) { o.setAttribute('aria-pressed', o === c ? 'true' : 'false'); });
        items.forEach(function (it) { it.hidden = !(f === 'alle' || it.dataset.oTopics === f); });
      });
    });
  }

  /* ---------- Vergleich (Handy): Vergleichsspalte umschalten ---------- */
  function initCmp(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var btns = [].slice.call(el.querySelectorAll('[data-o-cmpbtn]'));
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        el.setAttribute('data-o-cmp', b.dataset.oCmpbtn);
        btns.forEach(function (o) { o.setAttribute('aria-pressed', o === b ? 'true' : 'false'); });
      });
    });
  }

  /* ---------- Zitat-Bühne (Kundenstimmen) ---------- */
  function initRvs(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var slides = [].slice.call(el.querySelectorAll('[data-o-rvslide]'));
    var dots = [].slice.call(el.querySelectorAll('.o-rvs__dots span'));
    if (slides.length < 2) return;
    var cur = 0, timer = null, paused = false, inView = false;
    function go(i) {
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, n) { s.classList.toggle('is-active', n === cur); s.setAttribute('aria-hidden', n === cur ? 'false' : 'true'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-active', n === cur); });
      plan();
    }
    function plan() {
      clearTimeout(timer);
      if (!reduce && !paused && inView) timer = setTimeout(function () { go(cur + 1); }, 7000);
    }
    var prev = el.querySelector('[data-o-rvprev]'), next = el.querySelector('[data-o-rvnext]');
    if (prev) prev.addEventListener('click', function () { go(cur - 1); });
    if (next) next.addEventListener('click', function () { go(cur + 1); });
    var stage = el.querySelector('.o-rvs__stage'), x0 = null, y0 = 0;
    stage.addEventListener('mouseenter', function () { paused = true; plan(); });
    stage.addEventListener('mouseleave', function () { paused = false; plan(); });
    stage.addEventListener('focusin', function () { paused = true; plan(); });
    stage.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { paused = true; go(cur + (dx < 0 ? 1 : -1)); }
    }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { inView = en[0].isIntersecting; plan(); }, { threshold: 0.4 }).observe(el);
    go(0);
  }

  /* ---------- Herkunftskarte: Punkt und Karte gemeinsam hervorheben ---------- */
  function initKarte(el) {
    if (el.dataset.oReady) return;
    el.dataset.oReady = '1';
    var pins = [].slice.call(el.querySelectorAll('[data-o-pin]'));
    var cards = [].slice.call(el.querySelectorAll('[data-o-pincard]'));
    function on(i) {
      pins.forEach(function (p) { p.classList.toggle('is-on', p.dataset.oPin === String(i)); });
      cards.forEach(function (c) { c.classList.toggle('is-on', c.dataset.oPincard === String(i)); });
    }
    cards.forEach(function (c) {
      ['mouseenter', 'focus', 'click'].forEach(function (ev) { c.addEventListener(ev, function () { on(c.dataset.oPincard); }); });
    });
    pins.forEach(function (p) { p.addEventListener('mouseenter', function () { on(p.dataset.oPin); }); });
    on(0);
  }

  /* ---------- Goldstaub: PC = Spur der Maus (dunkle Bereiche/Bühnen), Handy = Lichtstrahl mit treibendem Staub (Bühnen) ---------- */
  function rnd(a, b) { return a + Math.random() * (b - a); }
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  function initBeam(stage) {
    if (reduce || finePointer || stage.dataset.oBeam) return;
    stage.dataset.oBeam = '1';
    var beam = document.createElement('div');
    beam.className = 'o-beam';
    beam.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < 10; i++) {
      var s = document.createElement('span');
      var z = rnd(1.2, 2.4);
      s.style.cssText = 'left:' + rnd(8, 60).toFixed(1) + '%;top:' + rnd(35, 95).toFixed(1) + '%;width:' + z.toFixed(1) + 'px;height:' + z.toFixed(1) + 'px;animation-duration:' + rnd(12, 18).toFixed(1) + 's;animation-delay:-' + rnd(0, 16).toFixed(1) + 's';
      beam.appendChild(s);
    }
    stage.appendChild(beam);
  }
  if (!reduce && finePointer) {
    var lastDust = 0;
    document.addEventListener('pointermove', function (e) {
      if (e.pointerType !== 'mouse' || !e.target.closest) return;
      var host = e.target.closest('.orbit-pdp.o-stage, .orbit-pdp.o-scheme--dunkel');
      if (!host) return;
      var now = Date.now();
      if (now - lastDust < 100) return;
      lastDust = now;
      var r = host.getBoundingClientRect();
      var p = document.createElement('span');
      var z = rnd(1.5, 3.2);
      p.className = 'o-dust';
      p.setAttribute('aria-hidden', 'true');
      p.style.cssText = 'left:' + (e.clientX - r.left + rnd(-5, 5)).toFixed(0) + 'px;top:' + (e.clientY - r.top + rnd(-5, 5)).toFixed(0) + 'px;width:' + z.toFixed(1) + 'px;height:' + z.toFixed(1) + 'px';
      host.appendChild(p);
      setTimeout(function () { p.remove(); }, 1500);
    }, { passive: true });
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll('.orbit-pdp.o-stage').forEach(initBeam);
    scope.querySelectorAll('[data-o-karte]').forEach(initKarte);
    scope.querySelectorAll('[data-o-rvs]').forEach(initRvs);
    scope.querySelectorAll('[data-o-cmp]').forEach(initCmp);
    scope.querySelectorAll('[data-o-sym]').forEach(initSym);
    scope.querySelectorAll('[data-o-ritual]').forEach(initRitual);
    scope.querySelectorAll('[data-o-topicbar]').forEach(initTopics);
    scope.querySelectorAll('[data-o-gallery]').forEach(initGallery);
    scope.querySelectorAll('[data-o-tilt]').forEach(initTilt);
    scope.querySelectorAll('[data-o-reveal]').forEach(initReveal);
    scope.querySelectorAll('[data-o-sticky]').forEach(initSticky);
    scope.querySelectorAll('[data-o-quiz]').forEach(initQuiz);
    scope.querySelectorAll('.orbit-pdp [data-tp="stars"], .orbit-pdp[data-tp="stars"]').forEach(initTpAnim);
    scope.querySelectorAll('[data-o-rezept]').forEach(initRezept);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();

  /* Theme-Editor: Sektionen neu initialisieren */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
